module.exports = __webpack_public_path__ + "static/media/6_r_ruini2_89.38_32.13.14ed8d8a.png";